export function isConversationVisible(panel) {
  return (
    !!panel &&
    document.visibilityState === 'visible' &&
    document.hasFocus() &&
    panel.getClientRects().length > 0
  );
}

export function isAtConversationBottom(panel) {
  return (
    !!panel && panel.scrollHeight - panel.clientHeight - panel.scrollTop <= 24
  );
}

export function latestReadableMessage(messages) {
  return messages
    .filter(
      message =>
        Number.isInteger(message.id) &&
        !message.private &&
        [0, 1].includes(message.message_type)
    )
    .reduce(
      (latest, message) =>
        !latest ||
        message.created_at > latest.created_at ||
        (message.created_at === latest.created_at && message.id > latest.id)
          ? message
          : latest,
      null
    );
}
